import { useEffect, useState } from 'react'
import uniqueId from 'lodash/uniqueId'

export const registerListener = ( element, event, func, options ) => {
  element.addEventListener
    ? element.addEventListener( event, func, options )
    : element.attachEvent( 'on' + event, func )
}

export const removeListener = ( element, event, func, options ) => {
  element.removeEventListener
    ? element.removeEventListener( event, func, options )
    : element.detachEvent( 'on' + event, func )
}

function getWindowDimensions() {
  if( typeof window === 'undefined' ) {
    return {
      width: 0,
      height: 0,
    }
  }

  const {
    innerWidth: width,
    innerHeight: height
  } = window

  return { width, height }
}

export const useWindowDimensions = () => {
  const [ windowDimensions, setWindowDimensions ] = useState( getWindowDimensions() )

  useEffect( () => {
    function handleResize() {
      setWindowDimensions( getWindowDimensions() )
    }

    registerListener( window, 'resize', handleResize )

    return () => removeListener( window, 'resize', handleResize )
  }, [] )

  return windowDimensions
}

export const useUniqueIds = ( items, key = 'uniqueId' ) => {
  const [ itemsWithIds, setItemsWithIds ] = useState( [] )

  useEffect( () => {
    setItemsWithIds( items.map( item => {
      item[ key ] = uniqueId()

      return item
    }))
  }, [ items, key ] )

  return itemsWithIds
}
